// extracted by mini-css-extract-plugin
export default {"card":"CardSection_card__ZlM-U","label":"CardSection_label__tgovP","image":"CardSection_image__5shI1"};